$(document).ready(function () {
    generateEA();

    $('.contact-navigate').on('click', function () {

        let params = new FormData();
        params.append('schoolid', schoolId);
        params.append('type', 'navigation');
        params.append('schoolType', schoolType);


        axios.post(`${APP_BASE_URL}/include/ajax_click.php`, params).then(res => {
            if (DEBUG) console.log("success", res);
        }).catch(err => {
            if (DEBUG) console.log("error", err);
        });
    });

    $('#callSchool').on('click', function () {

        let params = new FormData();
        params.append('schoolid', schoolId);
        params.append('type', 'call');
        params.append('schoolType', schoolType);


        axios.post(`${APP_BASE_URL}/include/ajax_click.php`, params).then(res => {
            if (DEBUG) console.log("success", res);
        }).catch(err => {
            if (DEBUG) console.log("success", err);
        });
    });

    $('.contact-website').on('click', function () {

        let params = new FormData();
        params.append('schoolid', schoolId);
        params.append('type', 'website');
        params.append('schoolType', schoolType);


        axios.post(`${APP_BASE_URL}/include/ajax_click.php`, params).then(res => {
            if (DEBUG) console.log("success", res);
        }).catch(err => {
            if (DEBUG) console.log("success", err);
        });
    });

    $('.contact-email').on('click', function () {

        let params = new FormData();
        params.append('schoolid', schoolId);
        params.append('type', 'email');
        params.append('schoolType', schoolType);


        axios.post(`${APP_BASE_URL}/include/ajax_click.php`, params).then(res => {
            if (DEBUG) console.log("success", res);
        }).catch(err => {
            if (DEBUG) console.log("success", err);
        });
    });

    $('.contact-phone').on('click', function () {

        let params = new FormData();
        params.append('schoolid', schoolId);
        params.append('type', 'phone');
        params.append('schoolType', schoolType);


        axios.post(`${APP_BASE_URL}/include/ajax_click.php`, params).then(res => {
            if (DEBUG) console.log("success", res);
        }).catch(err => {
            if (DEBUG) console.log("success", err);
        });
    });
});


function generateEA() {

    let params = new FormData();
    params.append('school_url', schoolUrl);
    params.append('schoolType', schoolType);

    mainApiAxios.post(`/school-view`, params).then(res => {
        if (DEBUG) console.log("success", res);
        if (pageType && pageType === 'UAE_DETAILS-PAGE' && typeof updateEventUserId !== 'undefined') updateEventUserId();
    }).catch(err => {
        if (DEBUG) console.log("error", err);
        if (pageType && pageType === 'UAE_DETAILS-PAGE' && typeof updateEventUserId !== 'undefined') updateEventUserId();
    });

}
